export const getHistoricalEntryUser = (name: string, value: string) => {
  const [firstname, firstSurname, ...rest] = name.split(" ");
  let surname = firstSurname;
  if (rest.length > 0) {
    surname += " " + rest.join(" ");
  }
  return {
    ref: "",
    firstname,
    surname,
    userid: value,
  };
};
